<!--
@Author: Calvin Green <calvin>
@Date:   2022-03-02T11:43:30+02:00
@Email:  calvin@diversitude.com
@Last modified by:   calvin
@Last modified time: 2022-05-17T20:11:15+02:00
@Copyright: Diversitude 2022
-->



<template>
    <b-card no-body>
        <template #header>
            <div class="d-flex">
                <b-button @click="$router.back()" size="sm" variant="outline-secondary" class="me-2">
                    <i class="fas fa-arrow-left"></i>
                </b-button>
                <strong class="pt-1">
                    Distribution Request for
                    <span class="text-primary" v-if="sop_data">
                        {{ sop_data.name }}
                    </span>
                </strong>
            </div>
        </template>

        <b-alert variant="success" :show="true" class="ms-2 me-2" dismissible>
            <strong>
                <i class="fa fa-check me-2"></i>
                Document distribution was successful
            </strong>
        </b-alert>

        <b-row>
            <b-col cols="6" sm="8">
                <!-- <annotate-pdf
                    v-if="b64 != null && show_document"
                    :sign_mode="false"
                    :base64="b64"/> -->
                <div v-if="b64 != null && show_document">
                    <iframe :src="getIframeSrc" style="width: 100%; height: 80vh;"></iframe>
                </div>
                <b-alert v-else show>{{ message }}</b-alert>
            </b-col>
            <b-col cols="6" sm="4">
                <b-card title="Distribution">
                    <b-row>
                        <b-col>
                            <b-button :variant="returnStyle('uncontrolled')" :disabled="distribution_type !== 'uncontrolled'">
                                Uncontrolled
                            </b-button>
                        </b-col>
                    </b-row>
                    <hr>
                    <b-row>
                        <b-col cols="12">
                            <b-overlay :show="is_loading">
                                <template #overlay>
                                        
                                        <h5 class="">
                                            <i class="fas fas fa-circle-notch fa-spin me-2"></i>Submitting...
                                        </h5>
                                </template>
                            <b-form class="">
                                <b-row>
                                    <b-col cols="12" class="mb-3">
                                        <b-form-group id="name" label="Copy Holder Name" label-for="name-input">
                                            <b-form-input id="name-input" size="sm" v-model="form.name" placeholder="Name of copy holder" required></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12">
                                        <b-form-group id="email" label="Copy Holder Email" label-for="email-input">
                                            <b-form-input size="sm" id="email-input" v-model="form.email" type="email" placeholder="Copy holder email" required></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col class="mt-3" cols="12">
                                        <b-form-group id="reason" label="Reason" label-for="reason-input">
                                            <b-form-textarea size="sm" id="reason-input" v-model="form.reason_text" rows="4" no-resize placeholder="Reason for copy request"></b-form-textarea>
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12" class="mt-2">
                                        <b-button :disabled="disableButton" @click="saveData" variant="success">
                                            SEND
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </b-form>
                        </b-overlay>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </b-card>
</template>

<script>
//eslint-disable-next-line
import _ from 'lodash'
import { sopMethods, sopState, layoutMethods } from "@/state/helpers"
export default {
    props:{
        sop_id:{}
    },
    data:() => ({
        was_saved_success: false,
        revision: null,
        sop_details: null,
        revision_id: null,
        has_mounted: false,
        is_loading: false,
        show_document: false,
        b64: null,
        distribution_type: 'uncontrolled',
        message: 'Waiting for document data',
        form:{
            name: '',
            reason_text: '',
            email: '',
        }
    }),
    computed:{
        ...sopState,
        disableButton(){
            if(this.form.reason_text === '' || this.form.email === '' || this.form.name === '' || this.b64 == null){
                return true;
            }
            else{
                return false;
            }
        },
        getIframeSrc(){
            return `${this.b64}#toolbar=0`;
        },
        sop_revisions(){
            if(this.sop_data != null){
                return this.sop_data.client_revisions;
            }
            else{
                return [];
            }
        },
    },
    methods:{
        ...layoutMethods,
        ...sopMethods,
        returnStyle(type){
            if(type === 'distribution_type'){
                return 'success'
            }
            else{
                return 'light'
            }
        },
        saveData(){
            let params = {
                client_revision_id: this.revision.client_revision_id,
                copy_holder_name: this.form.name,
                copy_holder_email: this.form.email,
                reason_for_copy: this.form.reason_text,
            }
            //console.log(params);
            this.is_loading = true;
            this.distributeSOP(params)
            .then(()=>{
                this.$swal.fire({ toast: true, position: 'top', iconColor: 'green', icon: 'success', title:'Success', showConfirmButton: false, timer: 2000, timerProgressBar: true});
                this.form = {
                    name: '',
                    reason_text: '',
                    email: ''
                };
                this.is_loading = false;
            })
            .catch(()=>{
                this.is_loading = false;
            })
        },
        loadError(){
            this.$swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Document does not exist!',
            })
            .then(()=>{
                this.$router.push({ name: 'documents' });
            })
        },
        loadB64(){
            this.b64 = null;
            window.axios({
                url: 'api/clientdocadmin/b64preview/' + this.revision.client_revision_id,
                method: 'GET',
                responseType: 'blob',
            })
            .then((response) => {
                this.b64 = window.URL.createObjectURL(response.data);
                this.show_document = true;
            }).catch(() => {
                this.show_document = false;
            });
        },
        showDistMenu(){
            this.hideMenu = false;
            this.updateMenuType({
                type: 'client_admin_distribution',
                showMenu: true,
                showRoutes: false,
            })
        },
    },
    mounted(){
        //this.is_loading = true;
        //this.showDistMenu();
        //this.loadSopData(this.sop_id)
        //.then(()=>{
        //    this.is_loading = false;
        //    this.has_mounted = true;
        //    this.findPublishedSop();
        //})
        this.showDistMenu();
        if(this.$route.params.document_id){
            this.loadSopData(this.$route.params.document_id)
            .then(()=>{
                if(this.sop_revisions.length > 0){
                    //this.revision = this.sop_revisions[this.sop_revisions.length - 1];
                    this.revision = this.sop_revisions.find( item => {
                        return item.published == 1;
                    })
                    if(this.revision){
                        this.loadB64();
                    }
                    else{
                        this.loadError();
                    }
                    
                }
                else{
                    this.loadError();
                }
            })
            .catch(()=>{
                this.loadError();
            })
        }
        else{
            this.loadError();
        }
    },
}
</script>

<style>

</style>
